import { createSlice } from "@reduxjs/toolkit";
import { ACL_LIST } from "../constants";

const initialState = {
  aclList: [],
};
export const AclSlice = createSlice({
  name: ACL_LIST,
  initialState,
  reducers: {
    addToAclList: (state, action) => {
      const data = {
        ...state,
        aclList: action.payload,
      };
      return (state = data);
    },
  },
});

export const { addToAclList } = AclSlice.actions;

export default AclSlice.reducer;
